module.exports = __webpack_public_path__ + "img/Group-157.2b29fa19.svg";